import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Row, Button } from 'react-bootstrap';
const uuid = require('uuid');
const get = require('lodash/get');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const FeatureUtil = require('../../../../app/shared/FeatureUtil');
const StringUtil = require('../../../../app/shared/StringUtil');
const AssetUtil = require('../../util/asset');

const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
import Navigator from '../../Navigator';
import WithDocumentVisible from '../DataHOCs/WithDocumentVisible';
import WithSignInStoreState from '../DataHOCs/WithSignInStoreState';
import WithChannelData from '../DataHOCs/WithChannelData';
import WithProjectData from '../DataHOCs/WithProjectData';
import LocalCourseInstanceCreateUI from './LocalCourseInstanceCreateUI';
import MainNav from '../DashboardNew/Menu/MainNav';
import SubNav from '../nav/SubNav';
import BackButton from '../nav/BackButton';
import SideNav from '../nav/SideNav';
import { ActivityBreadCrumbs } from '../nav/NavBreadCrumbs';
import DateString from '../common/DateString';
import Tooltip from '../common/Tooltip';
import UserFullName from '../user/UserFullName';
import UserDisplayName from '../user/UserDisplayName';
import ErrorBox from '../common/ErrorBox';
import WarningBox from '../common/WarningBox';
import ConfirmModal from '../modal/ConfirmModal';
import ConfirmPhraseModal from '../modal/ConfirmPhraseModal';
import SingleInputModal from '../modal/SingleInputModal3';
import CopyShortCourseModal from '../modal/CopyShortCourseModal';
import SelectProjectModal from '../modal/SelectProjectModal';
import ShortCourseSavesTable from './ShortCourseSavesTable';
import PublishShortCourseModal from '../modal/PublishShortCourseModal';
import WithShortCourseLockPoll from '../DataHOCs/WithShortCourseLockPoll';
import AssetImage from '../common/AssetImage';
import SingleAssetInput from '../common/SingleAssetInput';
import AddShortCourseLicenseModal from '../modal/AddShortCourseLicenseModal';
import UpdateShortCourseLicenseMetaDataModal from '../modal/UpdateShortCourseLicenseMetaDataModal';
import AddLicenseForUserModal from '../modal/AddLicenseForUserModal';

const propTypes = {
    history: PropTypes.object.isRequired,
    shortCourseId: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    channelId: PropTypes.string.isRequired,
    documentVisible: PropTypes.bool.isRequired,
    signInStoreState: PropTypes.shape({
    	initialized: PropTypes.bool.isRequired,
    	userInfo: PropTypes.shape({
    		admin: PropTypes.bool,
    	}).isRequired,
    }).isRequired,
    projectStoreState: PropTypes.shape({
        initialized: PropTypes.bool.isRequired,
        shortCourseProject: PropTypes.object.isRequired
    }).isRequired,
    channelStoreState: PropTypes.shape({
        initialized: PropTypes.bool.isRequired,
        channel: PropTypes.object.isRequired
    }).isRequired,
    editLock: PropTypes.object.isRequired,
};

const defaultProps = {};

class ShortCourseView extends React.Component {
    constructor(props) {
        super(props);

        const shortCourseStoreState = ShortCourseStore.getStateShortCourse(props.shortCourseId, props.projectId, props.channelId);
        this.state = {
			shortCourseStoreState,
            imageUpdateActionID: null,
			showInstanceCreateUI: '',
			devDisablePolling: false,
			updateCourseActionId: null,
			updateError: null,
			showConfirmDeleteModal: false,
			showRenameModal: false,
			showCopyModal: false,
			showTransferModal: false,
			showPublishModal: false,
			showUnpublishModal: false,
			showAddLicenseModal: false,
			showUpdateLicenseMetaDataModal: false,
			showAddLicenseForUserModal: false,
			renameCourseActionId: null,
			renameError: null,
			deleteCourseActionId: null,
			deleteError: null,
			displayTitle: '',
			displayTitleClean: true,
			description: '',
			descriptionClean: true,
			licenseMetaData: null,
			licenseMetaDataClean: true,
			copyActionId: null,
			copyError: null,
			transferActionId: null,
			transferError: null,
			unpublishActionId: null,
			unpublishError: null,
        };

        this.refreshShortCourse = this.refreshShortCourse.bind(this);
        this.refreshShortCourseSaves = this.refreshShortCourseSaves.bind(this);
        this.gotoEditor = this.gotoEditor.bind(this);
        this.gotoReview = this.gotoReview.bind(this);
        this.gotoPreview = this.gotoPreview.bind(this);
		this.gotoAnalytics = this.gotoAnalytics.bind(this);
        this.hideInstanceCreateUI = this.hideInstanceCreateUI.bind(this);
        this.showLocalInstanceCreateUI = this.showLocalInstanceCreateUI.bind(this);
        this.setDisplayTitle = this.setDisplayTitle.bind(this);
        this.setDescription = this.setDescription.bind(this);
		this.setLicenseMetaData = this.setLicenseMetaData.bind(this);
		this.updateLicenseMetaDataBadgeImage = this.updateLicenseMetaDataBadgeImage.bind(this);
        this.onUpdateCourse = this.onUpdateCourse.bind(this);
		this.onRenameCourse = this.onRenameCourse.bind(this);
		this.onCopyCourse = this.onCopyCourse.bind(this);
		this.onTransferCourse = this.onTransferCourse.bind(this);
		this.onUnpublishCourse = this.onUnpublishCourse.bind(this);
		this.noOp = this.noOp.bind(this);
		this.toggleShowRenameModal = this.toggleShowRenameModal.bind(this);
		this.toggleShowConfirmDeleteModal = this.toggleShowConfirmDeleteModal.bind(this);
		this.toggleShowCopyModal = this.toggleShowCopyModal.bind(this);
		this.toggleShowTransferModal = this.toggleShowTransferModal.bind(this);
		this.toggleShowPublishModal = this.toggleShowPublishModal.bind(this);
		this.toggleShowUnpublishModal = this.toggleShowUnpublishModal.bind(this);
		this.onDeleteCourse = this.onDeleteCourse.bind(this);
        this.unsubscribes = [
        	ShortCourseStore.listen(this.onShortCourseStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        if (this.props.channelStoreState.initialized && !this.props.channelStoreState.channel) {
            Navigator.goToDashboardAuthorView(this.props.history, Globals.view_tokens.dashboard.AUTHORING);
            return;
        }

        if (this.props.projectStoreState.initialized && !this.props.projectStoreState.shortCourseProject) {
			Navigator.goToDashboardAuthorAuthoringChannelView(
				this.props.history,
				this.props.channelId,
				null,
				{ queryObj: { cType: Globals.content_type.COURSE }, addLeadingQuestionMark: true }
			);
            return;
        }

        this.refreshShortCourse(true);
        this.updateInterval = window.setInterval(this.refreshShortCourse, 30000);
    }

    componentWillUnmount() {
    	window.clearInterval(this.updateInterval);
    	this.unsubscribes.forEach(u => u());
    }

    onShortCourseStoreChange(state) {
    	const newShortCourseStoreState = ShortCourseStore.getStateShortCourse(this.props.shortCourseId, this.props.projectId, this.props.channelId);
        if (newShortCourseStoreState.initialized && !newShortCourseStoreState.shortCourse) {
            this.backHandler();
            return;
        }

        // error in initial load when navigating directly to this view. likely permission denied or does not exist
        if (!newShortCourseStoreState.initialized && state.action.id === 'short-course-poll' && state.action.error) {
        	console.warn(state.action.error);
        	this.backHandler();
        	return;
        }

        let callback = null;
        let newState = { shortCourseStoreState: newShortCourseStoreState };
        
        if (state.action.id === this.state.updateCourseActionId) {
        	if (!state.action.error) {
        		newState = {
					...newState,
					updateCourseActionId: null,
					updateError: null,
					displayTitleClean: true,
					descriptionClean: true,
					licenseMetaDataClean: true,
					showUpdateLicenseMetaDataModal: false
				};
        	}
        	else {
        		newState = { ...newState, updateCourseActionId: null, updateError: state.action.error };
        	}
        }
        else if (state.action.id === this.state.deleteCourseActionId) {
        	if (!state.action.error) {
        		this.backHandler();
        		return;
        	}
        	else {
				newState = { ...newState, deleteCourseActionId: null, deleteError: state.action.error };
        	}
        }
        else if (state.action.id === this.state.renameCourseActionId) {
        	if (!state.action.error) {
        		newState = { ...newState, renameCourseActionId: null, showRenameModal: false, renameError: null };
        	}
        	else {
        		newState = { ...newState, renameCourseActionId: null, renameError: state.action.error };
        	}
        }
        else if (state.action.id === this.state.copyActionId) {
        	if (!state.action.error) {
        		newState = { ...newState, copyActionId: null, showCopyModal: false, copyError: null };
        	}
        	else {
        		newState = { ...newState, copyActionId: null, copyError: state.action.error };
        	}
        }
        else if (state.action.id === this.state.transferActionId) {
        	if (!state.action.error) { //todo: transition to new project destination?
        		// newState = { ...newState, transferActionId: null, showTransferModal: false, transferError: null };
        		this.backHandler();
        		return;
        	}
        	else {
        		newState = { ...newState, transferActionId: null, transferError: state.action.error };
        	}
        }
        else if (state.action.id === this.state.unpublishActionId) {
        	if (!state.action.error) {
        		newState = { ...newState, unpublishActionId: null, showUnpublishModal: false, unpublishError: null };
        		callback = this.refreshShortCourseSaves;
        	}
        	else {
        		newState = { ...newState, unpublishActionId: null, unpublishError: state.action.error };
        	}
        }
        else if (state.action.id === this.state.imageUpdateActionID) {
            newState = {
                ...newState,
                imageUpdateActionID: null
            };
        }
        else if (state.action.id === this.state.updateLicenseMetaDataActionId) {
            newState = {
                ...newState,
                updateLicenseMetaDataActionId: null
            };
        }

        this.setState(newState, () => {
        	if (!!callback) callback();
        });
    }

    refreshShortCourse(init=false) {
        if (
            !init
            && (!this.props.documentVisible || this.state.devDisablePolling)
        ) {
            return;
        }

        ShortCourseActions.getShortCourseWithLatestDoc(
            'short-course-poll',
            {
                shortCourseId: this.props.shortCourseId,
                channelId: this.props.channelId
            }
        );
    }

    refreshShortCourseSaves() {
		// mimic WithShortCourseSavesPoll action id to update ShortCourseSavesTable
		ShortCourseActions.getShortCourseSaves('course-saves-poll', { shortCourseId: this.props.shortCourseId });
    }

    backHandler=()=>{
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}#${this.props.shortCourseId}`);
    }

    gotoEditor() {
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/short_course/${this.props.shortCourseId}/edit`);
    }

    gotoReview() {
    	this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/short_course/${this.props.shortCourseId}/review`);
    }

    gotoPreview() {
    	this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/short_course/${this.props.shortCourseId}/preview`);
    }

    gotoAnalytics() {
        this.props.history.push(`/analytics/${this.props.channelId}/${this.props.projectId}/short_course/${this.props.shortCourseId}`);
    }

    gotoCourseInstance(createInstanceResultRoute) {
        // use window.location.href rather than router due to LTI client split from main
        window.location.href = createInstanceResultRoute;
    }

	showLocalInstanceCreateUI() {
		this.setState({ showInstanceCreateUI: Globals.integration_type.LOCAL });
	}

	hideInstanceCreateUI() {
		this.setState({ showInstanceCreateUI: '' });
	}

    setDisplayTitle(e) {
        this.setState({ displayTitle: e.target.value, displayTitleClean: false })
    }

    setDescription(e) {
        this.setState({ description: e.target.value, descriptionClean: false });
    }

	setLicenseMetaData(newMetaData) {
		this.setState({ licenseMetaData: newMetaData, licenseMetaDataClean: false });
	}

    updateLicenseMetaDataBadgeImage=(curMetaData, assetParams, files) => {
        const shortCourse = this.state.shortCourseStoreState.shortCourse;
        const imageUpdateActionID = uuid.v4();
        let params = {
			...assetParams, 
            courseHash: shortCourse.hash,
            asset_name: `course ${this.props.shortCourseId} image`
        };
        this.setState({ imageUpdateActionID }, ()=>{
            // after updating state, upload the image
            ShortCourseActions.addShortCourseVersionAsset(imageUpdateActionID, params, files, (asset_url) => {
                // after uploading the badge image, set badge_image_url in meta data, mark as dirty, wait for user to confirm changes
				console.log('curMetaData', curMetaData);
				console.log('badge image url', asset_url);
				this.setLicenseMetaData({
					...curMetaData,
					badge_image_url: asset_url,
				});
            });
        });
    }

	onUpdateCourse() {
		const params = {};
		if (!this.state.displayTitleClean) {
			params.display_title = this.state.displayTitle;
		}

		if (!this.state.descriptionClean) {
			params.description = this.state.description;
		}

		if (!this.state.licenseMetaDataClean) {
			params.course_license_meta_data = this.state.licenseMetaData
		}

		if (Object.keys(params).length === 0) {
			console.debug('No parameters to update. Skipping action.');
			return;
		}

		const updateCourseActionId = uuid.v4();
		this.setState({ updateCourseActionId: updateCourseActionId }, () => {
			ShortCourseActions.updateShortCourse(updateCourseActionId, {
				channelId: this.props.channelId,
				shortCourseId: this.props.shortCourseId,
				...params
			});
		});
	}

	onRenameCourse(newName) {
		const renameCourseActionId = uuid.v4();
		this.setState({ renameCourseActionId: renameCourseActionId }, () => {
			ShortCourseActions.renameShortCourse(renameCourseActionId, {
				channelId: this.props.channelId,
				shortCourseId: this.props.shortCourseId,
				title: newName,
			});
		});
	}

	onCopyCourse(title, toProjectId) {
		const copyActionId = uuid.v4();
		this.setState({ copyActionId: copyActionId }, () => {
			ShortCourseActions.copyShortCourse(copyActionId, {
				channelId: this.props.channelId,
				shortCourseId: this.props.shortCourseId,
				title: title,
				toProjectId: toProjectId,
				fromProjectId: this.props.projectId,
			});
		});
	}

    onTransferCourse(toProjectId) {
        const transferActionId = uuid.v4();
        this.setState({ transferActionId: transferActionId }, () => {
            ShortCourseActions.transferShortCourse(transferActionId, {
            	channelId: this.props.channelId,
                shortCourseId: this.props.shortCourseId,
                toProjectId: toProjectId,
                fromProjectId: this.props.projectId
            });
        })
    }

    onUnpublishCourse(message='') { // TODO allow message
        const unpublishActionId = uuid.v4();
        this.setState({ unpublishActionId: unpublishActionId }, () => {
            ShortCourseActions.unpublishShortCourse(unpublishActionId, {
            	channelId: this.props.channelId,
                shortCourseId: this.props.shortCourseId,
                unpublishMessage: message,
            });
        })
    }

    noOp(e) {
        return;
    }
    
    updateImage=(assetParams, files)=>{
        const shortCourse = this.state.shortCourseStoreState.shortCourse;
        const imageUpdateActionID = uuid.v4();
        let params = {...assetParams, 
            courseHash: shortCourse.hash,
            asset_name: `course ${this.props.shortCourseId} image`
        };
        this.setState({ imageUpdateActionID },()=>{
            // after updating state, upload the image
            ShortCourseActions.addShortCourseVersionAsset(imageUpdateActionID, params, files, (asset_url)=>{
                // after uploading the image, set image_url
                const updateCourseActionId = uuid.v4();
                this.setState({ updateCourseActionId },()=>{
                    ShortCourseActions.updateShortCourse(updateCourseActionId, {
                        channelId: this.props.channelId,
                        shortCourseId: this.props.shortCourseId,
                        image_url: asset_url,
                    });
                });
            });
        });
    }

    updateImageOnError=(errorMsg)=>{
        window.alert(errorMsg || 'Error');
    }
    

	toggleShowRenameModal(showBool) {
		this.setState({ showRenameModal: showBool });
	}

	toggleShowConfirmDeleteModal(showBool) {
		this.setState({ showConfirmDeleteModal: showBool });
	}

	toggleShowCopyModal(showBool) {
		this.setState({ showCopyModal: showBool });
	}

	toggleShowTransferModal(showBool) {
		this.setState({ showTransferModal: showBool });
	}

	toggleShowPublishModal(showBool) {
		this.setState({ showPublishModal: showBool });
	}

	toggleShowUnpublishModal(showBool) {
		this.setState({ showUnpublishModal: showBool });
	}

	toggleShowAddLicenseModal(showBool) {
		this.setState({ showAddLicenseModal: showBool });
	}

	toggleShowUpdateLicenseMetaDataModal(showBool) {
		this.setState({ showUpdateLicenseMetaDataModal: showBool });
	}

	toggleShowAddLicenseForUserModal(showBool) {
		this.setState({ showAddLicenseForUserModal: showBool });
	}

	onDeleteCourse() {
		const deleteCourseActionId = uuid.v4();
		this.setState({ deleteCourseActionId: deleteCourseActionId, showConfirmDeleteModal: false }, () => {
			ShortCourseActions.archiveShortCourse(deleteCourseActionId, {
				channelId: this.props.channelId,
				projectId: this.props.projectId,
				shortCourseId: this.props.shortCourseId,
			});
		});
	}

    render() {
        if (
            ! this.props.signInStoreState.initialized
            || !this.props.channelStoreState.initialized
            || !this.props.projectStoreState.initialized
            || !this.state.shortCourseStoreState.initialized
        ) {
            return <div/>;
        }

        const shortCourse = this.state.shortCourseStoreState.shortCourse;
        const project = this.props.projectStoreState.shortCourseProject;
        const channel = this.props.channelStoreState.channel;
        const hasAnyPublishes = !!shortCourse.latest_published_version;
        const shortCourseImageUrl = shortCourse.image_url || undefined;

        const isOrgChannel = Globals.users.is_org_account_type(channel.channel_account_type_token);
        const userInfo = this.props.signInStoreState.userInfo;
        let actions = [];
        const canEditShortCourse = PermissionsUtil.canEditShortCourse(channel.user_permissions, project.user_permissions);
        const courseLocked = this.props.editLock && this.props.editLock.locked;
        const courseLockStale = this.props.editLock && this.props.editLock.lockStale;
        const ltiUrl = GlobalConfig.ApiUrl + "/authoring/lti";
        const lti13Url = GlobalConfig.ApiUrl + "/authoring/oidc/launch";

        if (
            canEditShortCourse
            && (!courseLocked || courseLockStale)
        ) {
            actions.push({
                value: Strings['en'].common.EDIT_LC,
                handler: this.gotoEditor,
                group: 0,
            });
        }

        if (PermissionsUtil.canReviewShortCourse(channel.user_permissions, project.user_permissions)) {
            actions.push({
                value: Strings['en'].short_course.actions.REVIEW,
                handler: this.gotoReview,
                group: 0,
            });
        }

        actions.push({
            value: Strings['en'].short_course.actions.PREVIEW,
            handler: this.gotoPreview,
            group: 0,
        });

		if (userInfo.admin) {
			actions.push({
				value: Strings['en'].short_course.actions.ADD_LICENSE,
				handler: this.toggleShowAddLicenseModal.bind(this, true),
				group: 1,
			});

			actions.push({
				value: Strings['en'].short_course.actions.UPDATE_LIC_META,
				handler: this.toggleShowUpdateLicenseMetaDataModal.bind(this, true),
				group: 1,
			});

			actions.push({
				value: Strings['en'].short_course.actions.ADD_USER_LIC,
				handler: this.toggleShowAddLicenseForUserModal.bind(this, true),
				group: 1,
			});
		}

        const canPublishShortCourse = PermissionsUtil.canPublishShortCourse(channel.user_permissions, project.user_permissions);
        const canRenameShortCourse = PermissionsUtil.canRenameShortCourse(channel.user_permissions, project.user_permissions);
        if (!courseLocked) {
	        if (canPublishShortCourse) {
	        	if (shortCourse.latest_version !== shortCourse.latest_published_version) {
		            actions.push({
		                value: Strings['en'].short_course.actions.PUBLISH_SC,
		                handler: this.toggleShowPublishModal.bind(this, true),
		                group: 0,
		            });         		
	        	}

	        	if (shortCourse.ever_published) {
		            actions.push({
		                value: Strings['en'].short_course.actions.UNPUBLISH_SC,
		                handler: this.toggleShowUnpublishModal.bind(this, true),
		                group: 0,
		            });        	
	        	}
	        }

	        if (PermissionsUtil.canDeleteShortCourse(channel.user_permissions, project.user_permissions)) {
	            actions.push({
	                value: Strings['en'].common.DELETE_LC,
	                handler: this.toggleShowConfirmDeleteModal.bind(this, true),
	                group: 0,
	            });
	        }

	        if (canRenameShortCourse) {
	            actions.push({
	                value: Strings['en'].short_course.actions.RENAME_SC,
	                handler: this.toggleShowRenameModal.bind(this, true),
	                group: 0,
	            });
	        }

	        if (PermissionsUtil.canDuplicateShortCourse(channel.user_permissions, project.user_permissions)) {
	            actions.push({
	                value: Strings['en'].short_course.actions.COPY_SC,
	                handler: this.toggleShowCopyModal.bind(this, true),
	                group: 0,
	            });
	        }

	        if (PermissionsUtil.canMoveShortCourse(channel.user_permissions, project.user_permissions)) {
	            actions.push({
	                value: Strings['en'].short_course.actions.MOVE_SC,
	                handler: this.toggleShowTransferModal.bind(this, true),
	                group: 0,
	            });
	        }

        }

		if (
			FeatureUtil.hasDetailedAnalytics(channel.channel_permissions)
			&& PermissionsUtil.viewDetailedProjectAnalytics(channel.user_permissions, project.user_permissions)
		) {
			actions.push({
				value: Strings['en'].short_course.actions.SC_ANALYTICS,
				handler: this.gotoAnalytics,
				group: 0,
				//bgColor: '#cccccc',
				iconClass: 'fa-bar-chart'
			});
		}

        const isOwnChannel = !!userInfo && userInfo.id === parseInt(channel.id, 10);
        const accountHasAdHocAssignment = FeatureUtil.hasAdHocAssignments(channel.channel_permissions);
        const userCanCreateAdHocAssignment = PermissionsUtil.canCreateAdHocAssignment(channel.user_permissions, project.user_permissions);
        let createTooltipText;
        let canCreateLocalAssignment;
        if (accountHasAdHocAssignment && userCanCreateAdHocAssignment) {
            canCreateLocalAssignment = true;
        }
        else {
            canCreateLocalAssignment = false;

            if (!isOrgChannel) {
                if (isOwnChannel && !accountHasAdHocAssignment) {
                    createTooltipText = `Upgrade to a ${StringUtil.getStingForAccountType(Globals.users.account_types.INDIVIDUAL)} License to access this feature`;
                }
                else if (!isOwnChannel) {
                    createTooltipText = "You are not in your own channel (can't make course instances from other users' activities)"; //'Not available for your Project role.'
                }

            }
            else {
                if (accountHasAdHocAssignment && !userCanCreateAdHocAssignment) {
                    createTooltipText = 'Not available for your Organization or Project role.';
                }
                else if (!accountHasAdHocAssignment) {
                    createTooltipText = 'Not available for your Organization\'s license type.';
                }
            }
        }

		const displayTitle = this.state.displayTitleClean ? shortCourse.display_title || '' : this.state.displayTitle;
		const description = this.state.descriptionClean ? shortCourse.description || '' : this.state.description;

        //course locked element=================================================================
        let lockedElem = null;
        if (courseLocked) {
            let warningText;
            if (!courseLockStale) {
                warningText = !!this.props.editLock.userName ?
                    <span>Course Locked: {this.props.editLock.userName} editing</span>
                    :
                    <span>Course Locked: Editing in progress</span>;
            }
            else {
                warningText = !!this.props.editLock.userName ? <span>Course Locked (Lock Expired): {this.props.editLock.userName} was editing but lock was not released. Edit activity to unlock.</span> : <span>Course Locked: Editing lock was not released. Edit activity to unlock.</span>;
            }

            lockedElem = <WarningBox> {warningText} </WarningBox>;
        }

        return (
	        <div className="activity-page">
	            <MainNav
					onClickBrandLogo={() => Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.channelId, null, { queryObj: { cType: Globals.content_type.COURSE }, addLeadingQuestionMark: true })}
				/>
	            <div className="container main-container">
	                <SubNav
	                    menuClasses="d-inline-block d-sm-none"
	                    actions={ actions }
	                    //bgColor="#BED896"
	                >
	                    <BackButton backHandler={this.backHandler} />
	                    <div className="view-info-container">
	                        <div className="view-title">
	                            {shortCourse.title}
	                        </div>
	                        <div className="view-description">
	                            <ActivityBreadCrumbs
	                                channel={channel}
	                                project={project}
	                                foldersFlat={this.props.channelStoreState.shortCourseFoldersFlat}
	                            />
	                        </div>
	                    </div>
	                </SubNav>
	                <Row className="mzl-cs-content main-content-nav">
	                    <div className="col-sm-9 col-12 main-content">
	                        <div className="section">
	                            <div className="value-container inline-block margin-right-15">
	                                <div className="heading">Author</div>
	                                <div className="value-default-color">
	                                    {isOrgChannel ?
	                                        <UserDisplayName id={project.channelId} />
	                                        :
	                                        <UserFullName id={project.channelId} />
	                                    }
	                                </div>
	                            </div>
	                            <div className="value-container inline-block margin-right-15">
	                                <div className="heading">Created</div>
	                                <div className="value-default-color"><DateString date={shortCourse.created_at}/></div>
	                            </div>
	                            <div className="value-container inline-block margin-right-15">
	                                <div className="heading">Last Updated</div>
	                                { shortCourse.modified_at ?
	                                    <div className="value-default-color">
	                                        <DateString date={shortCourse.modified_at} showTime />
	                                    </div>
	                                    :
	                                    <div className="value-default-color">
	                                        <DateString date={shortCourse.modified_at} showTime />
	                                    </div>
	                                }
	                            </div>
	                        </div>
	                        <div className="section">
	                        	{lockedElem}
	                            {/* (GlobalConfig.DevMode && userInfo.admin) &&
	                                <Button
	                                    variant="warning"
	                                    onClick={this.toggleDisablePolling}
	                                    style={{position: 'absolute', top: '15px', right: '15px'}}
	                                >
	                                    {this.state.devDisablePolling ? "DEV: Resume Polling" : "DEV: Pause Polling"}
	                                </Button>
	                            */}

	                            <ErrorBox error={this.state.updateError} />
	                            <ErrorBox error={this.state.deleteError} />
	                            <Row>
	                                <div className="value-container col-12 col-sm-6">
	                                    <div className="margin-bottom-sm">
	                                        <label htmlFor="act-display-name">Short Course Display Title</label>
	                                        <Tooltip className="margin-left-sm" id="act-display-name-tooltip" placement="right">
	                                            When present, the Course Display Title will be used in place of the Course Title in the context of assigned courses.
	                                        </Tooltip>
	                                    </div>
						                <input
						                    type="text"
						                    className="actEditMetaDataInput margin-bottom-md"
						                    value={displayTitle}
						                    placeholder={shortCourse.title}
						                    disabled={!canEditShortCourse}
						                    onChange={this.setDisplayTitle}
						                />
	                                    <div className="margin-bottom-sm">
	                                        <label htmlFor="act-description">Short Course Description</label>
	                                        <Tooltip className="margin-left-sm" id="act-display-name-tooltip" placement="right">
	                                            When present, the Short Description will be shown in student & teacher course views.
	                                        </Tooltip>
	                                    </div>
	                                    <textarea 
	                                    	className="actEditMetaDataInput margin-bottom-md"
	                                    	placeholder="Write a description of your course here"
	                                    	value={description}
	                                    	rows='4'
	                                    	disabled={!canEditShortCourse}
	                                    	onChange={this.setDescription}
	                                    />
						                {(canEditShortCourse) &&
						                    <div>
						                        <Button
						                            onClick={this.onUpdateCourse}
						                            disabled={
						                            	(this.state.displayTitleClean && this.state.descriptionClean)
						                            	|| !!this.state.updateCourseActionId
						                           	}
						                        >
						                            {Strings['en'].common.UPDATE}
						                        </Button>
						                    </div>
						                }
	                                </div>
	                                <div className="value-container col-12 col-sm-6 text-centered">
	                                    <AssetImage
		                                    src={shortCourseImageUrl}
		                                    alt="Custom Course Image"
		                                    className="parent-constrained"
		                                    aria-hidden={true}
		                                />
	                                    <div className="margin-top-md margin-bottom-xl">
	                                        <SingleAssetInput
	                                            buttonOnly
	                                            browseText="Upload Course Image"
	                                            assetType="image"
	                                            assetRole="normal"
	                                            accept="image/*"
	                                            onChange={this.updateImage}
	                                            onError={this.updateImageOnError}
	                                            validateAssetType={AssetUtil.validateImageMimeType}
	                                            disabled={courseLocked || !!this.state.imageUpdateActionID || !canEditShortCourse}
	                                        />
	                                    </div>
	                                </div>
	                            </Row>
	                        </div>
	                        {(hasAnyPublishes) &&
		                        <div className="section">
	                                <h2 className="title">Sharing</h2>
	                                <hr className="thick hr-color-fg" />
						            <div className="assignment-create-button-div">
						                <span>
						                    <Button disabled={!canCreateLocalAssignment} onClick={this.showLocalInstanceCreateUI}>
						                        Create Course Instance in Author
						                    </Button>
						                    {(!!createTooltipText) &&
						                        <Tooltip id="tooltip-local-disabled" placement="right">{createTooltipText}</Tooltip>
						                    }
						                </span>
						            </div>
		                        </div>
	                        }
							{(hasAnyPublishes) &&
                                <div className="section">
									<h2 className="title">Integration</h2>
									<hr className="thick hr-color-fg"/>

									<div className="value-container">
										<div className="strong-heading">Course Id</div>
										<input
											type="text"
											className="form-control"
											value={shortCourse.hash}
											onChange={this.noOp}
											onClick={this.selectAllHandler}
										/>
									</div>
									<div className="value-container">
										<div className="strong-heading">LTI 1.1 Url</div>
										<input
											type="text"
											className="form-control"
											value={ltiUrl}
											onChange={this.noOp}
											onClick={this.selectAllHandler}
										/>
									</div>
									<div className="value-container">
										<div className="strong-heading">Custom Param: Specify Course Content Type (Required)</div>
										<input
											type="text"
											className="form-control"
											value={'custom_content_type=' + Globals.content_type.COURSE}
											onChange={this.noOp}
											onClick={this.selectAllHandler}
										/>
									</div>
									<div className="value-container">
										<div className="strong-heading">Custom Param: Course Id (Required)</div>
										<input
											type="text"
											className="form-control"
											value={'custom_course_id=' + shortCourse.hash}
											onChange={this.noOp}
											onClick={this.selectAllHandler}
										/>
									</div>
									<div className="value-container">
										<div className="strong-heading">Custom Param: Last Published Activity Version (Optional)</div>
										<input
											type="text"
											className="form-control"
											value={'custom_course_version=' + shortCourse.latest_published_version}
											onChange={this.noOp}
											onClick={this.selectAllHandler}
										/>
									</div>
								</div>
							}
                            <div className="section">
                                <h2 className="title">{Strings['en'].activity.SAVE_PUBLISH_HISTORY}</h2>
                                <hr className="thick hr-color-fg"/>
                                <ShortCourseSavesTable
                                    documentVisible={this.props.documentVisible}
                                    shortCourseId={this.props.shortCourseId}
                                    projectId={this.props.projectId}
                                    channelId={this.props.channelId}
                                    currentVersion={shortCourse.latest_version}
                                    /*disablePolling={this.state.devDisablePolling}*/
                                />
                            </div>
	                    </div>
	                    <SideNav className="d-none d-sm-block col-sm-3 mzl-cs-secondary-button-group" actions={actions} />
	                </Row>
	            </div>
	            {(this.state.showInstanceCreateUI === Globals.integration_type.LOCAL) &&
                    <LocalCourseInstanceCreateUI
                        courseId={shortCourse.id}
                        courseName={shortCourse.title}
                        onViewCourseInstance={this.gotoCourseInstance}
                        onClose={this.hideInstanceCreateUI}
                    />
	            }
                {(this.state.showConfirmDeleteModal) &&
                    <ConfirmModal
                        text={Strings['en'].short_course.DELETE_WARNING}
						buttonText={Strings['en'].common.DELETE_LC}
						cancelHandler={this.toggleShowConfirmDeleteModal.bind(this, false)}
						cancelButtonText={Strings['en'].common.CANCEL_LC}
                        confirmButtonBsStyle="danger"
                        confirmHandler={this.onDeleteCourse}
                        closeHandler={this.toggleShowConfirmDeleteModal.bind(this, false)}
                    />
                }
                {(this.state.showRenameModal) &&
                    <SingleInputModal
                        show
                        error={this.state.renameError}
                        disableButton={!!this.state.renameCourseActionId}
                        headerText={Strings['en'].short_course.modals.RENAME_COURSE_HD}
                        inputLabel={Strings['en'].short_course.modals.RENAME_COURSE_LABEL}
                        ariaLabel={Strings['en'].short_course.modals.RENAME_COURSE_LABEL}
                        buttonText={Strings['en'].common.CONFIRM_LC}
                        defaultValue={shortCourse.title}
                        closeHandler={this.toggleShowRenameModal.bind(this, false)}
                        submitHandler={this.onRenameCourse}
                    />
                }
                {(this.state.showCopyModal) &&
                	<CopyShortCourseModal
						submitHandler={this.onCopyCourse}
						projectId={this.props.projectId}
						sourceChannelId={this.props.channelId}
						closeHandler={this.toggleShowCopyModal.bind(this, false)}
						defaultValue={shortCourse.title + Strings['en'].common.ITEM_COPY_DEF_POST}
						error={this.state.copyError}
						disableButton={!!this.state.copyActionId}
                	/>
                }
                {(this.state.showTransferModal) &&
                    <SelectProjectModal
                        show
                        error={this.state.transferError}
                        headerText={Strings['en'].short_course.modals.MOVE_SC_HD}
                        buttonText={Strings['en'].common.MOVE_LC}
                        excludeProject={this.props.projectId}
                        permissionsFunc={PermissionsUtil.canCreateNewShortCourse}
                        closeHandler={this.toggleShowTransferModal.bind(this, false)}
                        submitHandler={this.onTransferCourse}
                        contentType={Globals.content_type.COURSE}
                        restrictToChannelId={this.props.channelId}
                    />
                }
                {(this.state.showPublishModal) &&
                	<PublishShortCourseModal
						shortCourseId={this.props.shortCourseId}
						projectId={this.props.projectId}
						channelId={this.props.channelId}
						onClose={this.toggleShowPublishModal.bind(this, false)}
						shortCourseLocked={false/*TODO*/}
						publishCallback={this.refreshShortCourseSaves}
                	/>
                }
                {(this.state.showUnpublishModal) &&
                    <ConfirmPhraseModal
                        closeHandler={this.toggleShowUnpublishModal.bind(this, false)}
                        cancelHandler={this.toggleShowUnpublishModal.bind(this, false)}
                        confirmButtonBsStyle="danger"
                        confirmPhrase={Strings['en'].short_course.actions.UNPUBLISH_SC}
                        confirmHandler={this.onUnpublishCourse}
                        cancelButtonText={Strings['en'].common.CANCEL_LC}
                        hasError={!!this.state.unpublishError}
                        message={get(this.state.unpublishError, 'message', null)}
                    >
                        <div className="margin-bottom-lg">
                            <p>{Strings['en'].short_course.UNPUBLISH_WARNING}</p>
                        </div>
                    </ConfirmPhraseModal>
                }
				{(this.state.showAddLicenseModal) &&
					<AddShortCourseLicenseModal
						shortCourseId={shortCourse.id}
						shortCourseHash={shortCourse.hash}
						onClose={this.toggleShowAddLicenseModal.bind(this, false)}
					/>
				}
				{(this.state.showAddLicenseForUserModal) &&
					<AddLicenseForUserModal
						shortCourseId={shortCourse.id}
						shortCourseHash={shortCourse.hash}
						onClose={this.toggleShowAddLicenseForUserModal.bind(this, false)}
					/>
				}
				{(this.state.showUpdateLicenseMetaDataModal) &&
					<UpdateShortCourseLicenseMetaDataModal
						disabled={this.state.licenseMetaDataClean || !!this.state.updateLicenseMetaDataActionId || !!this.state.imageUpdateActionID}
						uploadImageDisabled={!!this.state.updateLicenseMetaDataActionId || !!this.state.imageUpdateActionID}
						licenseMetaData={this.state.licenseMetaDataClean ? shortCourse.course_license_meta_data : this.state.licenseMetaData}
						error={this.state.updateError}
						onUpdate={this.setLicenseMetaData}
						onUpdateLicense={this.onUpdateCourse}
						onUpdateBadgeImage={this.updateLicenseMetaDataBadgeImage}
						onUpdateBadgeImageFailed={this.updateImageOnError}
						onClose={this.toggleShowUpdateLicenseMetaDataModal.bind(this, false)}
					/>
				}
	        </div>
	    );

    }
}


ShortCourseView.propTypes = propTypes;
ShortCourseView.defaultProps = defaultProps;

const WrappedComponent = withRouter(WithSignInStoreState(WithChannelData(WithProjectData(WithDocumentVisible(WithShortCourseLockPoll(ShortCourseView))))));

function WrappedComponentWithUpdatedPropNames(props) {
    return (
        <WrappedComponent
            {...props}
            shortCourseId={props.match.params.shortCourseId}
            projectId={props.match.params.projectId}
            channelId={props.match.params.channelId}
        />
    );
}

WrappedComponentWithUpdatedPropNames.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            channelId: PropTypes.string.isRequired,
            projectId: PropTypes.string.isRequired,
            shortCourseId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default WrappedComponentWithUpdatedPropNames;